import styles from "./antheRsTable.module.css";
// import Parser from 'html-react-parser'
import { useEffect, useState } from "react";
const AntheComplexTable = (props) => {
  const { data, exam_type } = props;
  const [rowData, setRowData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [subOccurrence, setSubOccurrence] = useState();
  let count = 0;
  const difficultyMap = {
    E: "Easy",
    M: "Moderate",
    H: "Difficult",
  };
  
  //Total score value IAT start
  let total_score = 0;
  let score_calculate = false;
  const [tscore, setScore] = useState(0)
  useEffect(() => { }, [tscore])
  //Total score value IAT end

  function transformData(originalData) {
    const transformedData = originalData.map((item) => {
      // Create an object with the desired keys and their corresponding values.con
      //Total score value IAT start
      if(score_calculate == false) {
        total_score = total_score + parseInt(item.score)
        setScore(total_score)
      }
      //Total score value IAT end
      return {
        Subject: item.subject,
        "Type of Questions": difficultyMap[item.difficulty],
        "Total No. of Questions": item.question_count,
        // "Maximum Score": parseInt(item.maximum_score),
        [exam_type === "IAT" ? "Marking Scheme" : "Maximum Score"]:
          parseInt(item.maximum_score),
        // "Your Score": item.score,
        [exam_type === "IAT" ? "Total Marks " : "Your Score"]: item.score,
      };
    });
    score_calculate = true;
    // Sort the transformed data first by subject and then by difficulty level.
    transformedData.sort((a, b) => {
      if (a.Subject < b.Subject) return -1;
      if (a.Subject > b.Subject) return 1;
      // Subjects are the same, so sort by difficulty.
      const difficultyOrder = ["Easy", "Moderate", "Difficult"];
      return (
        difficultyOrder.indexOf(a["Type of Questions"]) -
        difficultyOrder.indexOf(b["Type of Questions"])
      );
    });
    return transformedData;
  }

  useEffect(() => {
    if (props.data) {
      // Call the function to transform the data
      const transformedJSON = transformData(props.data.difficulty_analysis);
      let finalArr = transformedJSON;

      let head = [];
      Object.keys(finalArr[0]).map((item) => {
        head.push(item);
      });
      setTableHeader(head);

      let score = [];
      let subjectOccurrence = [];
      finalArr.map((item) => {
        let tableData = [];
        head.map((ele) => {
          tableData.push(item[ele]);
        });
        subjectOccurrence.push(item.Subject);
        score.push(tableData);
      });
      let obj = {};
      let mp = new Map();
      subjectOccurrence.map((item) => {
        if (mp.has(item)) mp.set(item, mp.get(item) + 1);
        else mp.set(item, 1);
      });
      for (const [key, value] of mp.entries()) {
        obj[key] = value;
      }
      setSubOccurrence(obj);
      setRowData(score);
    }
  }, [props]);

  // useEffect(() => {
  //     let head = []
  //     Object.keys(props.data.dla_sorted[0]).map((item) => {
  //         head.push(item)
  //     })
  //     setTableHeader(head)

  //     let score = []
  //     let subjectOccurrence = []
  //     props.data.dla_sorted.map((item) => {
  //         let tableData = []
  //         head.map((ele) => {
  //             tableData.push(item[ele])
  //         })
  //         subjectOccurrence.push(item.Subject)
  //         score.push(tableData)
  //     })
  //     let obj = {}
  //     let mp = new Map()
  //     subjectOccurrence.map((item) => {
  //         if (mp.has(item)) mp.set(item, mp.get(item) + 1)
  //         else mp.set(item, 1)
  //     })
  //     for (const [key, value] of mp.entries()) {
  //         obj[key] = value
  //     }
  //     setSubOccurrence(obj)
  //     setRowData(score)
  // }, [])

  return (
    <>
      {exam_type === "IAT" && (
        <div className={styles.difficut_analysis_section}>
          <p
            style={{
              color: "#009CDE",
              fontFamily: "Outfit-Medium",
              fontSize: "60px",
              marginBottom: "0",
              letterSpacing: "1.2px",
            }}
          >
            <b> COMPLEXITY LEVEL ANALYSIS</b>
          </p>
          <p
            style={{ fontFamily: "Outfit-Medium !important", fontSize: "30px", padding:"0px 143px", color:"#000" }}
            className="fw-bold"
          >
            Based on Comparison of Your Marks with Marks of the <br/>Maximum Scorer
          </p>
        </div>
      )}
      <div className={styles.tableWrapperComplex}>
        <div style={{ minWidth: "400px" }}>
          {exam_type === "iACST" && (
            <div className={styles.difficut_analysis_section}>
              <p
                style={{
                  color: exam_type === 'iACST' ? '#009CDE' : '#2B7DCA',
                  fontFamily: "Outfit-Medium",
                  fontSize: "54px",
                  marginBottom: "0",
                  letterSpacing: "1.2px",
                }}
              >
                <b> COMPLEXITY LEVEL ANALYSIS</b>
              </p>
              <p
                style={{ fontFamily: "Outfit-Medium !important", fontSize: "21px" }}
                className="fw-bold"
              >
                Based on Comparison of Your Marks with Marks of the Maximum Scorer
              </p>
            </div>
          )}
          {exam_type === "IAT" && (
            <div>
                {(props?.data?.profile?.class_studying === 'VII' || 
              props?.data?.profile?.class_studying === 'VIII' || 
              props?.data?.profile?.class_studying === 'IX') ? (
                <h6 className={styles.classwisecomplexity}>For Class - 7th, 8th & 9th</h6>
            ) : (
                <h6 className={styles.classwisecomplexity}>For Class - 10th, 11th, 12th & 12th Passed</h6>
            )}             
            </div>
          )}
        {(exam_type === "AKTHE" || exam_type === "ANTHE") && (
        <div className={styles.difficut_analysis_section}>
          <p
            style={{
              color: "#009CDE",
              fontFamily: "Outfit-Medium",
              fontSize: "60px",
              marginBottom: "0",
              letterSpacing: "1.2px",
            }}
          >
            <b> COMPLEXITY LEVEL ANALYSIS</b>
          </p>
          <p
            style={{ fontFamily: "Outfit-Medium !important", fontSize: "30px", padding:"0px 143px", color:"#000" }}
            className="fw-bold"
          >
            Based on Comparison of Your Marks with Marks of the Maximum Scorer
          </p>
        </div>
      )}
          <table className={styles.complexityTable}>
            <thead className={styles.antheCThead}>
              <tr className={styles.antheCTr}>
                {tableHeader.map((item, i) => {
                  return (
                    <th
                      key={i}
                      className={styles.cth}
                      style={
                        item.toLocaleLowerCase() === "subject"
                          ? { display: "none" }
                          : { textAlign: "center", fontSize: "22px" }
                      }
                      colSpan={
                        item.toLocaleLowerCase() === "type of questions" ||
                          item.toLocaleLowerCase() === "type of question"
                          ? 2
                          : null
                      }
                    >
                      {item}
                    </th>

                  );
                })}
                {exam_type === 'IAT' && (
                  <th
                    className={styles.cth}
                    rowSpan={3}
                    style={{ textAlign: "center", fontSize: "22px" }}
                  >
                    Duration
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {rowData.map((item, id) => {
                if (id > count) {
                  count += subOccurrence[item[0]];
                }
                return (
                  <tr key={"rowData" + id} className={styles.tableRowData}>
                    {id == count ? (
                      <td
                        style={{ fontSize: "22px" }}
                        rowSpan={subOccurrence[item[0]]}
                        className={styles.complexTableSubject}
                      >
                        {[item[0]]}
                      </td>
                    ) : null}
                    {item.map((ele, id) => {
                      return (
                        <td
                          key={"complexCol" + id}
                          style={
                            id == 0
                              ? { display: "none", fontWeight: "bold" }
                              : {
                                padding: "20px 3px",
                                fontWeight: "bold",
                                fontSize: "22px",
                              }
                          }
                          className={styles.colValue}
                        >
                          {ele}
                        </td>
                      );
                    })}

                    {/* Show only once: for first row only */}
                    {exam_type === 'IAT' && id === 6 ? (
                      <td
                        align="center"
                        valign="middle"
                        style={{
                          padding: "20px 3px",
                          fontWeight: "bold",
                          fontSize: "22px",
                          textAlign: "center",
                          color: "#000",
                          background:"#F6F6F6",
                          border:"none!important",
                        }}
                      >
                        3 Hrs
                       </td>
                    ) : !["iACST", "AKTHE","ANTHE"].includes(exam_type) ? (
                    <td
                        style={{
                          padding: "20px 3px",
                          fontWeight: "bold",
                          fontSize: "22px",
                          textAlign: "center",
                          color: "#000",
                          background:"#F6F6F6",
                          border:"none!important",
                        }}
                      >
                      </td>
                ) : null}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {exam_type !== "iACST" && exam_type !== "AKTHE" && exam_type !== "ANTHE" && (
          <table style={{ width: "100%",borderTop: "1px dashed #c5c6c6", fontSize:"22px" }}>
            <tr><td style={{width:"56%"}}>Total</td><td>{tscore}</td></tr>
          </table>
         )}
        </div>
      </div>
    </>
  );
};

export default AntheComplexTable;
